module.exports = __webpack_public_path__ + "img/cfx.db05fece.jpg";